import { isNativePlatform } from "@/lib/native";

if ("serviceWorker" in navigator && !isNativePlatform()) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker").catch((error) => {
      console.error("Service worker registration failed:", error);
    });
  });
}
